module.exports = __webpack_public_path__ + "img/03.0da5fb4d.jpg";